import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CurrentService } from '../../../services/current.service';
import { DatasService } from '../../../services/datas.service';
import { GTM } from 'src/app/services/gtm.service';
import { Router } from '@angular/router';
import { getHbmTotalSteps } from 'src/app/services/helpers/app-context-helper';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'ng-casto-kitchen-oven',
  templateUrl: './oven.component.html',
})
export class KitchenOvenComponent implements OnInit {
  @Output() onComplete: EventEmitter<void> = new EventEmitter();

  constructor(
    public current: CurrentService,
    public datas: DatasService,
    public gtm: GTM,
    private readonly router: Router,
    private readonly customer: CustomerService
  ) {}

  ngOnInit(): void {
    this.gtm.trackPage(`${this.router.url}/choix/four`, 'Cuisine | Choix', {
      stepNumber: 4,
      totalSteps: getHbmTotalSteps(this.customer.context),
    });
  }

  selectOvenConfiguration(ovenConfigurationRef: string) {
    this.current.kitchen.ovenConfigurationRef = ovenConfigurationRef;
    this.onComplete.emit();
  }
}
